//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The granted scopes of the user
*
* 
*  * PROMOTER_WRITE value: promoter:write - 
*  * ACCOUNT_READ value: account:read - 
*  * ACCOUNT_WRITE value: account:write - 
*  * CONSUMER_WRITE value: consumer:write - 
*  * TICKETS_WRITE value: tickets:write - 
*  * OPENID value: openid - 
*  * PROFILE value: profile - 
*  * EMAIL value: email - 
*  * OFFLINE value: offline_access - 
*/
@Serializable
enum class Scopes(val value: kotlin.String) {

    @SerialName(value = "promoter:write")
    PROMOTER_WRITE("promoter:write"),

    @SerialName(value = "account:read")
    ACCOUNT_READ("account:read"),

    @SerialName(value = "account:write")
    ACCOUNT_WRITE("account:write"),

    @SerialName(value = "consumer:write")
    CONSUMER_WRITE("consumer:write"),

    @SerialName(value = "tickets:write")
    TICKETS_WRITE("tickets:write"),

    @SerialName(value = "openid")
    OPENID("openid"),

    @SerialName(value = "profile")
    PROFILE("profile"),

    @SerialName(value = "email")
    EMAIL("email"),

    @SerialName(value = "offline_access")
    OFFLINE("offline_access");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is Scopes) "$data" else null

    /**
    * Returns a valid [Scopes] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): Scopes? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

